import React from 'react';

import { BesvartSporsmalRad, OppsummeringTabell } from '../components/oppsummering/oppsummering';
import erGyldigKontonummer from '../norsk-validator/erGyldigKontonummer';
import { CurrentKontaktinfosporsmal } from '../sporsmalsflyt/kontaktinfo/kontaktinfo-types';
import { IdentifikatorType } from '../sporsmalsflyt/reducer/sporsmalsflyt-types';

export interface Props {
    kontaktinfo: CurrentKontaktinfosporsmal;
}

export const KontaktinfoOppsummering = ({ kontaktinfo }: Props) => {
    return (
        <OppsummeringTabell header="Kontaktinfo">
            <BesvartSporsmalRad sporsmal="Fullt navn" svar={kontaktinfo.navn} />
            <BesvartSporsmalRad sporsmal="Mobilnummer" svar={kontaktinfo.mobilnummer} />
            <BesvartSporsmalRad sporsmal="E-post" svar={kontaktinfo.epost} />
            {kontaktinfo.identifikatorType === IdentifikatorType.Organisasjonsnummer && (
                <BesvartSporsmalRad sporsmal="Organisasjonsnummer" svar={kontaktinfo.organisasjonsnummer} />
            )}
            {erGyldigKontonummer(kontaktinfo.bankkontonummer) && (
                <BesvartSporsmalRad sporsmal="Bankkonto" svar={kontaktinfo.bankkontonummer} />
            )}
        </OppsummeringTabell>
    );
};
